import { roundness } from "@provider/dripsy";
import { Text, TextInput as TextInputNative, View } from "dripsy";
import * as React from "react";
import type { TextInputProps } from "react-native";

type DripsyProps = React.ComponentProps<typeof TextInputNative>;
type Props = TextInputProps & {
  label: string;
  color: string;
  error?: boolean;
  height?: number | string;
  sx?: DripsyProps["sx"];
};

function TextArea({ label, color, error, style, height = 180, ref, ...rest }: Props & { ref?: React.Ref<any> }) {
  const [focused, setFocused] = React.useState(false);

  return (
    <View
      sx={{
        height,
        borderWidth: 2,
        borderColor: focused ? "$lightGreen" : "$textGrey",
        borderRadius: roundness,
        margin: 8,
      }}
    >
      <View
        sx={{
          position: "absolute",
          top: -16,
          left: 10,
          backgroundColor: color,
          padding: 6,
        }}
      >
        <Text
          sx={{
            fontSize: 14,
            fontWeight: "500",
            color: focused ? "$lightGreen" : "$textGrey",
          }}
        >
          {label}
        </Text>
      </View>
      {/*@ts-ignore*/}
      <TextInputNative
        ref={ref}
        // placeholder={label}
        // placeholderTextColor={placeholderColor}
        multiline
        {...rest}
        sx={{
          fontSize: 16,
          fontWeight: "500",
          flex: 1,
          borderRadius: roundness,
          alignItems: "center",
          justifyContent: "flex-start",
          paddingLeft: "$2",
          paddingTop: "$2",
          outlineStyle: "none",
        }}
        onFocus={(e) => {
          setFocused(true);
          rest?.onFocus?.(e);
        }}
        onBlur={(e) => {
          setFocused(false);
          rest?.onBlur?.(e);
        }}
      />
    </View>
  );
}
export default TextArea;
